import { NS as commonNs } from './locales/common'
import { NS as exampleNs } from './locales/example'

export default {
  defaultNs: commonNs,
  NSs: [commonNs, exampleNs]
}
